import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  superficies: [],
  fetchSuperficiesLoading: false,
  fetchSuperficiesError: null,

  superficie: {},
  fetchSuperficieLoading: false,
  fetchSuperficieError: null,

  addSuperficieLoading: false,
  addSuperficieError: null,

  updateSuperficieLoading: false,
  updateSuperficieError: null,

  deleteSuperficieLoading: false,
  deleteSuperficieError: null
};

export const superficiesSlice = createSlice({
  name: 'SUPERFICIES',
  initialState,
  reducers: {
    fetchSuperficiesStart: state => {
      state.fetchSuperficiesLoading = true;
      state.fetchSuperficiesError = null;
    },
    fetchSuperficiesSuccess: (state, action) => {
      state.fetchSuperficiesLoading = false;
      state.superficies = action.payload;
    },
    fetchSuperficiesError: (state, action) => {
      state.fetchSuperficiesLoading = false;
      state.fetchSuperficiesError = action.payload;
    },

    fetchSuperficieStart: state => {
      state.fetchSuperficieLoading = true;
      state.fetchSuperficieError = null;
    },
    fetchSuperficieSuccess: (state, action) => {
      state.fetchSuperficieLoading = false;
      state.superficie = action.payload;
    },
    fetchSuperficieError: (state, action) => {
      state.fetchSuperficieLoading = false;
      state.fetchSuperficieError = action.payload;
    },

    addSuperficieStart: state => {
      state.addSuperficieLoading = true;
      state.addSuperficieError = null;
    },
    addSuperficieSuccess: (state, action) => {
      state.addSuperficieLoading = false;
      state.superficies.unshift(action.payload);
    },
    addSuperficieError: (state, action) => {
      state.addSuperficieLoading = false;
      state.addSuperficieError = action.payload;
    },

    updateSuperficieStart: state => {
      state.updateSuperficieLoading = true;
      state.updateSuperficieError = null;
    },
    updateSuperficieSuccess: (state, action) => {
      state.updateSuperficieLoading = false;
      const newState = state.superficies.map(superf => {
        if (superf.id === action.payload.id) return action.payload;
        return superf;
      });
      state.superficies = newState;
    },
    updateSuperficieError: (state, action) => {
      state.updateSuperficieLoading = false;
      state.updateSuperficieError = action.payload;
    },

    deleteSuperficieStart: state => {
      state.deleteSuperficieLoading = true;
      state.deleteSuperficieError = null;
    },
    deleteSuperficieSuccess: (state, action) => {
      state.deleteSuperficieLoading = false;
      const newState = state.superficies.filter(
        superf => superf.id !== action.payload.id
      );
      state.superficies = newState;
    },
    deleteSuperficieError: (state, action) => {
      state.deleteSuperficieLoading = false;
      state.deleteSuperficieError = action.payload;
    }
  }
});

export const {
  fetchSuperficiesStart,
  fetchSuperficiesSuccess,
  fetchSuperficiesError,
  fetchSuperficieStart,
  fetchSuperficieSuccess,
  fetchSuperficieError,
  addSuperficieStart,
  addSuperficieSuccess,
  addSuperficieError,
  updateSuperficieStart,
  updateSuperficieSuccess,
  updateSuperficieError,
  deleteSuperficieStart,
  deleteSuperficieSuccess,
  deleteSuperficieError
} = superficiesSlice.actions;

export default superficiesSlice.reducer;
